/** 검수 대기(REQUESTED) 상품 이전/다음 이동용 큐 */
export const ADMIN_REQUESTED_PRODUCT_QUEUE_KEY = 'jangi.admin.requestedProductQueue'

export function saveRequestedProductQueue(codes: string[]) {
  try {
    sessionStorage.setItem(ADMIN_REQUESTED_PRODUCT_QUEUE_KEY, JSON.stringify(codes))
  } catch {
    /* ignore quota */
  }
}

export function loadRequestedProductQueue(): string[] {
  try {
    const raw = sessionStorage.getItem(ADMIN_REQUESTED_PRODUCT_QUEUE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as unknown
    if (!Array.isArray(parsed)) return []
    return parsed.map((code) => String(code)).filter(Boolean)
  } catch {
    return []
  }
}
